var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3408 4.97789L19.0221 3.65918C18.583 3.21973 18.0072 3 17.4313 3C16.8554 3 16.2796 3.21973 15.8401 3.65883L3.45179 16.0472L3.00531 20.0627C2.94906 20.5683 3.34738 21 3.84203 21C3.87332 21 3.9046 20.9982 3.9366 20.9947L7.94933 20.5514L20.3412 8.15953C21.2197 7.28098 21.2197 5.85645 20.3408 4.97789ZM7.43288 19.477L4.1623 19.8395L4.52652 16.564L13.8039 7.2866L16.7138 10.1965L7.43288 19.477ZM19.5456 7.3643L17.509 9.4009L14.5991 6.49102L16.6357 4.45441C16.8481 4.24207 17.1307 4.125 17.4313 4.125C17.7319 4.125 18.0142 4.24207 18.2269 4.45441L19.5456 5.77312C19.984 6.21187 19.984 6.92555 19.5456 7.3643Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.51d763d92267a4e8842b087c1c21d608.svg";
export { ForwardRef as ReactComponent };